module.exports = __webpack_public_path__ + "static/media/Scorecard.7c705d50.svg";